import { styled } from '@styledComponents';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Button } from '@components/Button';

export const StyledSectionWrapper = styled(Flex)<{
  isVisible: boolean;
  backgroundImageTop: string;
  backgroundImageBottom: string;
}>`
  text-align: center;
  ${themeMediaQuery('below_sm')} {
    background-image: url(${(props) => (props.isVisible ? cloudAssetUrl(props.backgroundImageTop, { optimization: 'aggressive' }) : '')}),
      url(${(props) => (props.isVisible ? cloudAssetUrl(props.backgroundImageBottom, { optimization: 'aggressive' }) : '')});
    background-position: center top, 50% bottom;
    background-repeat: no-repeat, no-repeat;
    background-size: 190% auto;
    padding-top: 35%;
    padding-bottom: 55%;
  }
`;

export const StyledBox = styled(Flex)`
  margin: auto;
  flex-direction: column;
  width: 100%;
`;

export const BlogCenterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 210px;
  }
  .text-pairing-body {
    max-width: 355px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      text-align: center;
      font-size: 40px;
      line-height: 46.88px;
      margin-left: auto;
      margin-right: auto;
    }
    .text-pairing-body {
      margin: auto;
    }
    .text-pairing-eyebrow {
      text-align: center;
      width: 100%;
    }
    .text-pairing-body {
      text-align: center;
    }
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-body {
      width: 350px;
      max-width: 350px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 490px;
    }
    .text-pairing-body {
      width: auto;
      max-width: 430px;
    }
  }
`;

export const StyledColumnDesktop = styled(Columns.Column)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledBgDownColumn = styled(Flex)<{
  backgroundImage: string;
}>`
  ${themeMediaQuery('below_sm')} {
    background: no-repeat center bottom url(${(props) => cloudAssetUrl(props.backgroundImage)});
    background-size: 190% auto;
    padding-bottom: 166px;
  }
`;

export const StyledButtonBox = styled(Box)`
  width: 100%;
  text-align: left;
  ${themeMediaQuery('below_sm')} {
    text-align: center;
  }
`;

export const StyledButton = styled(Button)`
  ${themeMediaQuery('below_sm')} {
    padding: 0 15px;
    height: 45px;
    line-height: 43px;
  }
`;
